import Button from '@material-ui/core/Button'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import Typography from '@material-ui/core/Typography'
import AddIcon from '@material-ui/icons/Add'
import DragHandleIcon from '@material-ui/icons/DragHandle'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React from 'react'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'

import StructuredJsonBlockFields from './StructuredJsonBlockFields'

export default function StructuredJsonAccordion(props) {
  const { name, label, max, blocks, onAddItem, isNonArrayObject, onSort } = props
  const canAddItem = !max || max > blocks.length
  return (
    <>
      <Typography variant="body2">{label || name}</Typography>
      <SortableList
        {...props}
        onSortEnd={({ oldIndex, newIndex }) => {
          onSort(oldIndex, newIndex)
        }}
        useDragHandle={true}
      />
      {canAddItem && !isNonArrayObject && (
        <div style={{ textAlign: 'center', position: 'relative', top: -10 }}>
          <Button
            disableRipple
            onClick={onAddItem}
            variant="outlined"
            style={{ padding: 8, borderRadius: '50%', minWidth: 0 }}
          >
            <AddIcon />
          </Button>
        </div>
      )}
    </>
  )
}

const DragHandle = SortableHandle(({ style }) => (
  <DragHandleIcon
    onMouseDown={(e) => {
      e.stopPropagation()
      e.preventDefault()
    }}
    style={{ marginRight: 10, cursor: 'move', ...style }}
  />
))

const SortableList = SortableContainer((props) => {
  const { name, blocks } = props
  return (
    <div style={{ overflow: 'hidden' }}>
      {blocks.map((fields, index) => {
        const id = name + index
        return <SortableExpander key={id} index={index} idx={index} id={id} fields={fields} {...props} />
      })}
    </div>
  )
})

const SortableExpander = SortableElement((props) => {
  const {
    api,
    id,
    idx: index,
    name,
    label,
    fields,
    selected,
    labelKey,
    schema,
    jsonPath,
    isNonArrayObject,
    onDeleteItem,
    onSelect,
    onUpdate,
  } = props
  const expanded = selected === id
  return (
    <ExpansionPanel
      expanded={expanded}
      onChange={() => onSelect(id)}
      elevation={0}
      style={{ border: '1px solid rgb(204 204 204)' }}
    >
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
          <DragHandle
            style={
              isNonArrayObject
                ? { display: 'none' }
                : expanded
                ? { opacity: 0.3, pointerEvents: 'none' }
                : null
            }
          />
          <Typography>{labelKey ? fields[labelKey] : `${index + 1}. ${label || name}`}</Typography>
        </div>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails style={{ display: 'inherit', paddingTop: 0 }}>
        <StructuredJsonBlockFields
          index={index}
          name={name}
          fields={fields}
          schema={schema}
          jsonPath={jsonPath}
          isNonArrayObject={isNonArrayObject}
          api={api}
          onDeleteItem={isNonArrayObject ? undefined : onDeleteItem}
          onUpdate={onUpdate}
        />
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
})
